import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerActivityLog } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import type {
	GetPlayerActivityLogRequest,
	GetPlayerActivityLogResponse,
} from '../../../type'

export default function useQueryPlayerActivityLog(
	payload: GetPlayerActivityLogRequest,
	props?: UseBaseQueryOptions<GetPlayerActivityLogResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerActivityLog, payload],
		queryFn: () => getPlayerActivityLog(payload),
		...props,
	})
}
